export default __webpack_public_path__ + "static/media/img_tutor_howitworks_03@medium.9e1ad3dd.png";